import React, { useEffect, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { Filter } from "./component/Filter";
import { Checkbox } from "sr/helpers";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { Input } from "sr/helpers";
import { WhiteBtn } from "./component/WhiteBtn";
import { TableRow } from "./component/TableRow";
import { Link } from "react-router-dom";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { FormattedMessage, useIntl } from "react-intl";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getJob } from "sr/utils/api/individual/job/getJob";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { IndiJobStatus, individualJobStatus } from "sr/i18n/messages/setting";
import { getAddress } from "sr/utils/api/individual/address/getAddress";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { TermsAgreePopup } from "app/pages/module/auth/TermsAgreePopup";
import { AddressDisplay } from "sr/helpers/functions/AddressDisplay";
import { Pagination } from "app/pages/component/Pagination";
import { Button } from "sr/helpers/ui-components/company/Button";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { useSelector } from "react-redux";
import { RootState } from "sr/redux/store";
import { toast } from "react-toastify";
export const Jobs = () => {
  const intl = useIntl();
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState([]);
  const [userId, setUserId] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [locations, setLocations] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [totalPage, settotalPage] = useState(0);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);

  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserId(user_id);
    // no need to check payment flow
    (async () => {
      const userFullProfileRes = await getUserFullProfile();
      console.log("userFullProfileRes?.data", userFullProfileRes?.data);

      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, []);
  const fetchLocation = async (userId) => {
    try {
      const params = new URLSearchParams();
      if (userId) params.append("individual_id", userId);
      if (location) params?.append("location_id", location);
      params.append("status!", "deleted");
      const res = await getAddress(params);
      if (res?.success === true) {
        setLocations(res?.data);
      } else {
      }
    } catch (e: any) {}
  };
  const fetchJob = async () => {
    setLoader(true);
    try {
      const params = new URLSearchParams();
      if (userId) params.append("individual_id", userId);
      if (limit) params.append("limit", limit.toString());
      if (page) params.append("page", page.toString());
      if (status) params.append("status!", "deleted");
      if (jobStatus) params.append("work_status", jobStatus.toString());
      const res = await getJob(params);
      if (res?.success === true) {
        setData(res?.data);
        setLoader(false);
        settotalPage(Math.ceil(res?.pagination?.total / limit));
      } else {
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
      HandleApiError(e);
    }
  };
  useEffect(() => {
    if (userId) {
      fetchLocation(userId);
    }
  }, [userId]);
  useEffect(() => {
    if (userId) {
      fetchJob();
    }
  }, [userId, jobStatus, location, page]);
  return (
    <MainWrapper>
      <ContentWithSpinner loader={loader} height="h-screen">
        <div className="py-3">
          <div className="mb-2">
            <h1 className="text-2xl  border-r border-neutral-200 pr-4">
              <FormattedMessage
                id="INDIVIDUAL.JOBS.TITLE"
                defaultMessage="Jobs"
              />
            </h1>
            <p>
              <FormattedMessage
                id="INDIVIDUAL.JOBS.TEXT"
                defaultMessage="Use this page to manage your Jobs"
              />
            </p>
          </div>
          <div className="flex justify-between items-center">
            <div className="flex space-x-2 items-center">
              <DropDown
                labelClass="text-base"
                value={location}
                label={
                  <FormattedMessage
                    id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.ADDRESS"
                    defaultMessage="Address"
                  />
                }
                dropdowndiv="mt-1 w-56"
                onChange={(e) => setLocation(e.target.value)}
                className="cursor-pointer rounded-lg border-[#d4d2d0] py-1.5 hover:border-[#0078ae] hover:text-[#0078ae] focus:border-[#0078ae] focus:ring-0"
              >
                <option value="">
                  <FormattedMessage
                    id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.SELECT.ADDRESS"
                    defaultMessage="Select Address"
                  />
                </option>
                {locations?.map((item, index) => (
                  <option key={index} value={item?.value}>
                    {AddressDisplay(item?.address)}
                  </option>
                ))}
              </DropDown>
              {/* <Filter label={<FormattedMessage id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS" />} name={<FormattedMessage id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.FILTERSTATUS" defaultMessage="Filter Status" />}>
{IndiJobStatus?.map((item)=> (
<Checkbox checked={status.includes(item?.value)} label={item?.label} id={item?.value} name={item?.value} value={item?.value} onChange={(e)=> CheckBoxHandle(e, status, setStatus)} />
 ))}
 </Filter> */}
              <Filter
                mainClass="w-56"
                label={
                  <FormattedMessage id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.JOB.STATUS" />
                }
                name={
                  <FormattedMessage
                    id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.FILTERSTATUS"
                    defaultMessage="Filter Status"
                  />
                }
              >
                {individualJobStatus?.map((item) => (
                  <Checkbox
                    checked={jobStatus.includes(item?.value)}
                    label={item?.label}
                    id={item?.value}
                    name={item?.value}
                    value={item?.value}
                    onChange={(e) => CheckBoxHandle(e, jobStatus, setJobStatus)}
                  />
                ))}
              </Filter>
            </div>
            <Button
              text={
                <FormattedMessage
                  id="INDIVIDUAL.JOBS.POST_A_JOB.BUTTON"
                  defaultMessage="Post a Job"
                />
              }
              disabled={!userFullProfile?.id}
              onClick={() => {
                if (
                  appSettingsData &&
                  appSettingsData?.isPlatformPaymentActive != undefined &&
                  appSettingsData?.isPlatformPaymentActive === true
                ) {
                  if (
                    !userFullProfile?.id ||
                    !userFullProfile?.stripe_customer_detail ||
                    !userFullProfile?.stripe_customer_detail?.id ||
                    !userFullProfile?.stripe_customer_payment_methods ||
                    userFullProfile?.stripe_customer_payment_methods?.length ==
                      0
                  ) {
                    toast.error(
                      intl.formatMessage({
                        id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                        defaultMessage:
                          "Please set up your payment method first",
                      }),
                    );
                    return;
                  }
                  if (
                    !userFullProfile?.stripe_customer_detail ||
                    !userFullProfile?.stripe_customer_detail
                      ?.default_payment_method ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == null ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == "null" ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == ""
                  ) {
                    toast.error(
                      intl.formatMessage({
                        id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
                        defaultMessage:
                          "Please set a default payment method first",
                      }),
                    );
                    return;
                  }
                }

                window.location.href = "/individual/job-post-new";
              }}
            ></Button>
            {/* <Link to="/individual/job-post-new">
              <Button
                text={
                  <FormattedMessage
                    id="INDIVIDUAL.JOBS.POST_A_JOB.BUTTON"
                    defaultMessage="Post a Job"
                  />
                }
              ></Button>
            </Link> */}
          </div>

          {data?.length > 0 ? (
            <div className="overflow-x-auto mt-4 rounded-[20px]">
              <table className="w-full text-left condidate-table">
                <thead className="bg-[#FAF9F8] border-collapse border-b border-neutral-200 capitalize">
                  <tr>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.TITLE"
                        defaultMessage="Title"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.ADDRESS"
                        defaultMessage="Address"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.HOURLY_RATE"
                        defaultMessage="Hourly Rate($)"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.DATEANDTIME"
                        defaultMessage="Date And Time"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.STARTTIME"
                        defaultMessage="Start Time"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.STATUS"
                        defaultMessage="Status"
                      />
                    </th>
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="INDIVIDUAL.JOBS.TABLE.COL.ACTIONS"
                        defaultMessage="Actions"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => (
                    <TableRow item={item} setData={setData} />
                  ))}
                </tbody>
              </table>
              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
            </div>
          ) : (
            <div className="bg-white text-center w-full border border-neutral-200 py-28 mt-5 rounded-lg">
              <div className="pt-5 text-base ">No jobs have been added yet</div>
            </div>
          )}
        </div>
      </ContentWithSpinner>
      <TermsAgreePopup />
    </MainWrapper>
  );
};
